<template>
  <v-dialog v-model="show_dialog" max-width="510px">
    <template v-if="successful">
      <v-card>
        <v-card-title>
          <span class="text-h5">Повідомлення успішно підписане</span>
        </v-card-title>
        <v-card-text>
          <b>Код ЄДРПОУ: </b>{{ sign_data.cert.pszSubjEDRPOUCode }}<br />
          <b>Суб'єкт: </b>{{ sign_data.cert.pszSubject }}<br />
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </template>
    <template v-if="!successful">
      <v-card>
        <v-card-title>
          <span class="text-h5">Помилка створення підпису</span>
        </v-card-title>
        <v-card-text>
          {{ sign_data.detail }}
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  props: ["sign_data", "successful"],
  data: () => ({
    show_dialog: true,
  }),
  methods: {},
};
</script>